/*
 *
 * Artifactory is a binaries repository manager.
 * Copyright (C) 2018 JFrog Ltd.
 *
 * Artifactory is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 * Artifactory is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with Artifactory.  If not, see <http://www.gnu.org/licenses/>.
 *
 */
import {ArtifactsController} from './artifacts/artifacts.controller';
import {BrowsersController} from './browsers/browsers.controller';
import {jfTreeSearch} from './jf_tree_search/jf_tree_search';
import {jfTreeBrowser} from './jf_tree_browser/jf_tree_browser';
import {jfTrashPin} from './jf_tree_browser/jf_trash_pin';
import {jfStashBrowser} from './jf_stash_browser/jf_stash_browser';
import {selectTargetPathFactory} from './services/select_target_path';
import {commonGridColumns} from './services/common_grid_columns';
import {selectDeleteVersionsFactory} from './services/select_delete_versions';
import {jfArtifactInfo} from './jf_artifact_info/jf_artifact_info';
import infoTabs from './jf_artifact_info/info_tabs/info_tabs.module';

function artifactsConfig($stateProvider, $urlMatcherFactoryProvider) {

    $urlMatcherFactoryProvider.type('pathParam', {
        encode: function (item) {
            return item;
        },
        decode: function (item) {
            return item;
        },
        is: function (item) {
            return true;
        }
    });
    $stateProvider
            .state('artifacts', {
                url: '/artifacts',
                parent: 'app-layout',
                abstract: true,
                templateUrl: 'states/artifacts/artifacts.html',
                controller: 'ArtifactsController as Artifact',
                onExit: (ArtifactoryState, TreeBrowserDao) => {
                    // Stop saving last state of tree
                    ArtifactoryState.removeState('lastTreeState');
                    // Invalidate the tree node cache
//                    TreeBrowserDao.invalidateRoots();
                },
                onEnter: (ArtifactoryState) => {
                    // This should be true only when going from tree to simple before selecting any node in the tree
                    ArtifactoryState.setState('tree_touched', false);
                }
            })
            .state('artifacts.browsers', {
                url: '/browse/{browser}',
                templateUrl: 'states/artifacts/browsers/browsers.html',
                controller: 'BrowsersController as Browsers',
                onEnter: (ArtifactoryStorage, $stateParams) => {
                    if ($stateParams.browser !== 'stash') ArtifactoryStorage.setItem('BROWSER', $stateParams.browser);
                },
                params: {
                    clearFilter: null
                }
            })
            .state('artifacts.browsers.path', {
                url: '/{tab}/{artifact:pathParam}',
                onEnter: (JFrogEventBus, $stateParams, ArtifactoryState) => {
                    // Save state of tree
                    ArtifactoryState.setState('lastTreeState', {name: 'artifacts.browsers.path', params: $stateParams});
                    JFrogEventBus.dispatch(JFrogEventBus.getEventsDefinition().TABS_URL_CHANGED, $stateParams);
                },
                params: {
//                    forceLoad: false // used to force reload of state even if it's the same artifact
                }
            })
}

export default angular.module('artifacts', ['infoTabs'])
        .config(artifactsConfig)
        .controller('ArtifactsController', ArtifactsController)
        .controller('BrowsersController', BrowsersController)
        .directive('jfTreeSearch', jfTreeSearch)
        .directive('jfTreeBrowser', jfTreeBrowser)
        .directive('jfTrashPin', jfTrashPin)
        .directive('jfStashBrowser', jfStashBrowser)
        .directive('jfArtifactInfo', jfArtifactInfo)
        .factory('selectTargetPath', selectTargetPathFactory)
        .factory('commonGridColumns', commonGridColumns)
        .factory('selectDeleteVersions', selectDeleteVersionsFactory)



// WEBPACK FOOTER //
// ./states/artifacts/artifacts.module.js